import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=37f20252&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"
import style0 from "./ListGroup.vue?vue&type=style&index=0&id=37f20252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f20252",
  null
  
)

export default component.exports